import type { ReactNode } from 'react'

import { cn } from '@/shared/lib'

type KeyValueProps = {
  label: ReactNode
  /** Identifiers, amounts, timestamps and percentages are always mono. */
  isMono?: boolean
  size?: 'md' | 'lg'
  children: ReactNode
  className?: string
}

/** An 11px uppercase label over its value — the detail page's basic unit. */
export function KeyValue({
  label,
  isMono = false,
  size = 'md',
  children,
  className,
}: KeyValueProps) {
  return (
    // `min-w-0` so a value in a grid cell cannot push past its track, and the
    // wrap is `anywhere` because the values here are URLs, user agents and
    // header blobs — single tokens with no spaces to break at.
    <div data-slot="key-value" className={cn('flex min-w-0 flex-col gap-1.25', className)}>
      <div className="text-label tracking-label text-muted-foreground uppercase">{label}</div>
      <div
        className={cn(
          'min-w-0 [overflow-wrap:anywhere]',
          isMono && 'font-mono',
          size === 'lg' ? 'text-h2 text-foreground' : 'text-body text-fg-body',
        )}
      >
        {children}
      </div>
    </div>
  )
}
